import pdfPreview from './src/main'

pdfPreview.install = function (Vue) {
  Vue.component(pdfPreview.name, pdfPreview)
}

export default pdfPreview
